import { Injectable, HostListener } from '@angular/core';
import { EventManager } from '@angular/platform-browser';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root'})
export class ApplicationStateService {

  public isMobileResolution: boolean;
  public oldIsMobileResolution: boolean;

  // constructor() {
  //   this.checkSize();
  // }

  // @HostListener('window:resize', ['$event'])
  // onResize(event) {
  //   console.log('resize');
  //   this.checkSize();
  // }

  // private checkSize() {
  //   if (window.innerWidth < 768) {
  //     this.isMobileResolution = true;
  //   } else {
  //     this.isMobileResolution = false;
  //   }
  // }

  private resizeSubject: Subject<Window>;
  
  get onResize$(): Observable<Window> {
    return this.resizeSubject.asObservable();
  }

  constructor(private eventManager: EventManager) {
    this.resizeSubject = new Subject();
    this.eventManager.addGlobalEventListener('window', 'resize', this.onResize.bind(this));
    this.onResize(new UIEvent("resize"));
  }

  private onResize(event: UIEvent) {
    this.oldIsMobileResolution = this.isMobileResolution;

    if (window.innerWidth < environment.RESPONSIVE_SIZE) {
      this.isMobileResolution = true;
    } else {
      this.isMobileResolution = false;
    }

    // força recarrega i notificació només si hi ha un canvi de responsive
    if (this.oldIsMobileResolution != null && this.oldIsMobileResolution != this.isMobileResolution ){
      this.resizeSubject.next(<Window>event.target);
      setTimeout(function() { window.location.reload()});
    }
    
  }
}

